import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Authenticationservice } from './../../services/authentication.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { date } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'app-listaskformoneyheader',
  templateUrl: './listaskformoneyheader.component.html',
  styleUrls: ['./listaskformoneyheader.component.css']
})
export class ListaskformoneyheaderComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  zone: any;
  supcode: any;
  userlevel: any;
  Actiocmanager: UntypedFormGroup;

  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private route: ActivatedRoute) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlevel = userdata.userlevel;

    this.Actiocmanager = new UntypedFormGroup({
      comment_takeask: new UntypedFormControl(''),
      comment_save: new UntypedFormControl(''),
      comment_accept: new UntypedFormControl(''),
      text_back: new UntypedFormControl(''),
      //credit_approved: new UntypedFormControl(0),
      date: new UntypedFormControl(0),
    })
  }
  year_L = [    //รายการปี    
    { "yearTh": "6667", "yearCr": "2324", "yearDesc": "ปี 2566/2567", "status": 0 },
    { "yearTh": "6768", "yearCr": "2425", "yearDesc": "ปี 2567/2568", "status": 0 },
    { "yearTh": "6869", "yearCr": "2526", "yearDesc": "ปี 2568/2569", "status": 1 }
  ]
  year_S = [];//[{ "yearTh": "6768", "yearCr": "2425", "yearDesc": "ปี 2567/2568" }];

  n_name = [];
  displaylist = ['doc_no', 'supportter', 'date', 'fmcode', 'fullname', 'askfor', 'countmoney', 'status', 'timeline', 'save', 'cancle'];
  year: string

  ngOnInit(): void {
    this.year_S = this.year_L.filter((el: any) => el.status == 1);
    //this.year = this.route.snapshot.paramMap.get('year');
    let uvlv = this.userlevel;
    if (uvlv == '7') {
      this.n_name = [{ doc_status: '7', back: 'พนักงานสินเชื่อ', now: 'หัวหน้าแผนกสินเชื่อBRR', next: 'ผู้ช่วย ผจก.สินเชื่อ', next2: 'ผจก.สินเชื่อ' }];
    }
    else if (uvlv == '9') {
      this.n_name = [{ doc_status: '8', back: 'หัวหน้าแผนกสินเชื่อBRR', back2: 'พนักงานสินเชื่อ', now: 'ผู้ช่วย ผจก.สินเชื่อ', next: 'ผจก.สินเชื่อ' }];
    }
    else if (uvlv == '10') {
      this.n_name = [{ doc_status: '9', back: 'ผู้ช่วย ผจก.สินเชื่อ', back2: 'หัวหน้าแผนกสินเชื่อBRR', now: 'ผจก.สินเชื่อ' }];
    }
    console.log('n_name', this.n_name[0]);

    this.Loadlistaskformoney();
    this.loadtype_money();
  }

  applyFilter(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
  }

  Cancleid(data) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + data.firebaseid + "&doc_status='X'";
    console.log('url:', url);
    if (confirm("ต้องการยกเลิกรายการ คำขอ " + data.docid + " ?") == true) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("ยกเลิกรายการแล้วค่ะ");
          this.Loadlistaskformoney();
        }
        else {
          alert("!!! ไม่สำเร็จ !!!")
        }
      }).catch(err => { throw (err); })
    } else {
      return false;
    }
  }

  edit_st: number;
  // โหลดข้อมูล
  listdoc8: any;
  list6566data = [];
  listdoc9: any;
  newtable: any;
  data2 = { date_debt: '', typebank: '', Doc: '', bank: '', goto: 0, backto: 0 }

  Date_debt_l: Date;
  @ViewChild('listdoc89', { static: false }) listdoc89Table: any;

  Loadlistaskformoney() {
    console.log('this.year_S', this.year_S);
    let year = this.year_S[0];
    this.spinner.show();

    let dalv = this.n_name[0];
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance" + year.yearTh + "]&w=[doc_status] ='" + dalv.doc_status + "'"
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = (res.data);
      let alldoc
      if (data.length >= 1) {
        data.sort((a, b) => {
          return new Date(b.datepost).getTime() - new Date(a.datepost).getTime();
        });
        alldoc = data.map(item => {
          return {
            ...item, modify: false, money_amt_edit: item.money_amt
          };
        });
        this.edit_st = 0;
        this.listfinancedataA = alldoc;
        this.resetdata()
      }
      else {
        this.listfinancedataA = [];
        this.resetdata()
      }
    })
      .catch(err => { throw (err) })
  }


  datatype_m: any[];
  subtype0: any[];
  loadtype_money() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*,left([id],1)[l_id],RIGHT([id],1)[r_id]&f=[CPS6263].[dbo].[type_money]&w=1=1";
    axios.get(url)
      .then(res => {
        this.datatype_m = res.data;
        this.subtype0 = this.datatype_m.filter((el: any) => el.r_id == '0');
      }).catch(err => { throw (err); })

  }
  // เลือกประเภทย่อย
  listfinancedataA = [];
  subtype1: any[];
  subtypeSL: string;

  SubTypeSelectM(type0: string) {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    console.log('type0', type0)
    this.subtype1 = this.datatype_m.filter((el: any) => el.l_id == type0 && el.r_id != '0');
    this.list6566data = this.listfinancedataA.filter((el: any) => el.type_money.substr(0, 1) == type0);

    setTimeout(() => {
      this.newtable = $(this.listdoc89Table.nativeElement).DataTable({ order: [[0, 'desc']] });
    }, 100);
  }

  SubTypeSelectS(sc_id: string) {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    console.log('sc_id', sc_id)
    this.list6566data = this.listfinancedataA.filter((el: any) => el.type_money == sc_id);
    setTimeout(() => {
      this.newtable = $(this.listdoc89Table.nativeElement).DataTable({ order: [[0, 'desc']] });
    }, 100);
  }

  resetdata() {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    console.log('resetdata')
    this.list6566data = this.listfinancedataA;

    setTimeout(() => {
      this.newtable = $(this.listdoc89Table.nativeElement).DataTable({ order: [[0, 'desc']] });
    }, 100);
  }

  // ข้อมูลใน Modal
  credit_approved = 0;//ที่ขอ
  chkAccept: Array<any> = [
    1 // สถานะ 1 อนุมัติได้                            
    , 0 //ที่จะอนุมัติ
    , '' //ธนาคาร
    , null //วันที่อนุมัติ
  ];
  datainmodal: any;
  Datainmodel(data: any) {
    this.datainmodal = [data]//this.list6566data.filter(el => el.docid == docid);
    /*this.chkAccept[0] = 1;
    this.chkAccept[1] = this.datainmodal[0].money_amt;*/ //
    this.chkAccept = [1, data.money_amt,
      data.bank, new Date().toLocaleDateString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit' })]
    this.credit_approved = data.money_amt;
    //this.typebank = this.datainmodal[0].bank;

    /*console.log('chkAccept',this.chkAccept);
     */
    console.log('datainmodal[]', this.datainmodal);
  }
  ckcredit_approved() {
    if (this.chkAccept[1] < this.credit_approved) {
      this.chkAccept[0] = 3;
      alert('จำนวนเงินที่อนุมัติได้ ' + this.credit_approved + ' ต้องน้อยกว่าหรือเท่ากับ ' + this.chkAccept[1]);
    }
    else if (this.credit_approved <= 0) {
      this.chkAccept[0] = 3;
      alert('จำนวนเงินที่อนุมัติได้ ต้องมากกว่า 0');
    }
    else this.chkAccept[0] = 1;
  }

  async saveData() {
    let data = this.list6566data.filter((el: any) => el.modify == true);
    console.log('modify:', data);
    if (data.length > 0) {
      if (confirm(`ต้องการบันทึกข้อมูล | จำนวน ${data.length} คำขอ หรือไม่?`)) {
        let ins = 0;
        this.spinner.show();
        for (let i = 0; i < data.length; i++) {
          let ar0 = data[i];
          if (this.edit_st == 1) { this.AcceptFinance_s(ar0, i); }
          else if (this.edit_st == 2) { this.SendtoHeaderfinance2(ar0, i) }
          else if (this.edit_st == 3) { this.returnfinance2(ar0, i) }
          //console.log('i:', i, ', ins:', ins);
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        this.spinner.hide();
        alert("บันทึกข้อมูลแล้ว");
        setTimeout(() => {
          this.Loadlistaskformoney();
          //console.log('ins', ins);
        }, 500);
      }
    }
    else alert("ยังไม่มีการแก้ไขข้อมูล");
  }


  urlSendto2(firebaseid: string, comment: string, sent: number) {
    let uvlv = this.userlevel;
    let dalv = this.n_name[0], sent2 = '', str = '';
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?`;

    if (sent == 1) { sent2 = dalv.next2, str = '9'; }
    else { sent2 = dalv.next, str = '8'; }

    if (uvlv == '7') {
      url += `firebaseid=${firebaseid}&doc_status='${str}'&comment4='${comment}'&id_head='${this.supcode}'&comment4date=getdate()`;
    }
    else if (uvlv == '9') {
      url += `firebaseid=${firebaseid}&doc_status='9'&comment5='${comment}'&id_head='${this.supcode}'&comment5date=getdate()`;
    }
    return { url: url, sent2: sent2 }
  }

  datetransfer: Date
  // ส่งต่อ

  SendtoHeaderfinance2(item, i: number) {
    let d2 = this.data2;
    let data = this.urlSendto2(item.firebaseid, d2.Doc, d2.goto)
    console.log(i, 'SendtoHeaderfinance:', data);
    axios.post(data.url).then(res => {
      if (res.data.rowsAffected[0] >= 1) { }
      else { }
    }).catch(err => { throw (err) })


  }

  SendtoHeaderfinance(item, sent: number) {
    let comment = this.Actiocmanager.get('comment_takeask').value;
    let data = this.urlSendto2(item.docid, comment, sent)
    console.log('SendtoHeaderfinance:', data);
    if (confirm("ยืนยันการทำรายการ ส่งต่อ " + data.sent2)) {
      axios.post(data.url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          alert("ส่งต่อเรียบร้อย");
          setTimeout(() => {
            this.Loadlistaskformoney();
          }, 200);
        }
        else {
          alert("ไม่สำเร็จกรุณาลองใหม่");
        }
      }).catch(err => { throw (err) })
    }
    else {
    }
  }

  urlBackto2(firebaseid: string, comment: string, sent: number) {
    let uvlv = this.userlevel;
    let dalv = this.n_name[0], sent2 = '', now = '', str = '';
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?`;
    now = dalv.now;
    if (uvlv == '7') {

      sent2 = dalv.back;
      url += `[firebaseid]=${firebaseid}&[doc_status]='1'&[send_back]='Y'&[text_back]='${now}-${comment}'`;
    }
    else if (uvlv == '9') {
      if (sent == 1) { sent2 = dalv.back2, str = '1'; }
      else { sent2 = dalv.back, str = '7'; }
      url += `[firebaseid]=${firebaseid}&[doc_status]='${str}'&[send_back]='Y'&[text_back]='${now}-${comment}'`;
    }
    else if (uvlv == '10') {
      if (sent == 1) { sent2 = dalv.back2, str = '7'; }
      else { sent2 = dalv.back, str = '8'; }
      url += `[firebaseid]=${firebaseid}&[doc_status]='${str}'&[send_back]='Y'&[text_back]='${now}-${comment}'`;
    }
    return { url: url, sent2: sent2 }
  }

  returnfinance2(item, i: number) {
    let d2 = this.data2;
    let data = this.urlBackto2(item.firebaseid, d2.Doc, d2.backto)
    console.log('returnfinance:', data.url);

    axios.post(data.url).then(res => {
      if (res.data.rowsAffected[0] >= 1) {
        alert("ส่งกลับเรียบร้อย");
        setTimeout(() => {
          this.Loadlistaskformoney();
        }, 300);
      }
      else {
        alert("ไม่สำเร็จกรุณาลองใหม่");
      }
    }).catch(err => { throw (err) })

  }


  returnfinance(item, sent: number) {
    let comment = this.Actiocmanager.get('text_back').value;
    let data = this.urlBackto2(item.docid, comment, sent)

    console.log('returnfinance:', data.url);
    if (confirm("ยืนยันการทำรายการ ส่งกลับ " + data.sent2)) {
      axios.post(data.url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          alert("ส่งกลับเรียบร้อย");
          setTimeout(() => {
            this.Loadlistaskformoney();
          }, 300);
        }
        else {
          alert("ไม่สำเร็จกรุณาลองใหม่");
        }
      }).catch(err => { throw (err) })
    }
  }

  Date_debt: Date;
  typebank: String;

  AcceptFinance_s(data, i: number): void {
    let d = data
    let d2 = this.data2
    let date_d = this.date2en(d2.date_debt);
    let Date_debt = null
    if (date_d.length > 0) Date_debt = `'${date_d}'`
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=${d.firebaseid}&[doc_status]='4'`
      + `&[comment6]='${d2.Doc}'&[id_approve]='${this.supcode}'&[Date_debt]=${Date_debt}&money_amt=${d.money_amt}`
      + `&[credit_approved]=${d.money_amt}&[bank]='${d2.bank}'&[dateapprove]=getdate()`;
    console.log(`${i} AcceptFinance:`, url);
    axios.post(url).then(res => {
      if ((res.data.rowsAffected[0]) || 0 >= 1) { return 1 }
      else return 0
    }).catch(err => { throw (err) })
  }

  AcceptFinance(firebaseid: string) {
    let data = this.Actiocmanager
    let comment = this.Actiocmanager.get('comment_accept').value;
    let date_d = '';
    if (!this.Date_debt) {
      date_d = null;
    }
    else date_d = `'${this.Date_debt}'`;
    //console.log('Actiocmanager:', data);
    /*  let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_n?docid=" + doc_id + "&doc_status=4&comment5='" + comment + "'&id_approve='" 
      + this.supcode + "'&dateapprove=getdate()&credit_approved=" + this.credit_approved + "&bank='" + this.chkAccept[2] + "'&datetransfer='" + this.chkAccept[3] + "'";
      */
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=${firebaseid}&[doc_status]='4'&[comment6]='${comment}'&[id_approve]='${this.supcode}'&[Date_debt]=${date_d}&[dateapprove]=getdate()&[credit_approved]=${this.credit_approved}&[bank]='${this.chkAccept[2]}'`;
    if (this.chkAccept[0] == 1) {
      //console.log('AcceptFinance:', url);
      if (confirm("ยืนยันการการอนุมัติคำขอ " + this.datainmodal[0].docid + ' - ' + this.datainmodal[0].fmname)) {
        axios.post(url).then(res => {
          if (res.data.rowsAffected[0] >= 1) {
            alert("อนุมัติรายการเรียบร้อย");
            setTimeout(() => {
              this.Loadlistaskformoney();
            }, 100);
          }
          else {
            alert("ไม่สำเร็จกรุณาลองใหม่");
          }
        }).catch(err => { throw (err) })
      }
    } else { }

  }

  disapprovalFinance(firebaseid: string) {
    let comment = this.Actiocmanager.get('comment_accept').value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + firebaseid + "&doc_status='D'&comment6='" + comment + "'&id_approve='"
      + this.supcode + "'&dateapprove=getdate()";
    if (confirm("ยืนยันการการไม่อนุมัติคำขอนี้ " + this.datainmodal[0].docid + ' - ' + this.datainmodal[0].fmname)) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          setTimeout(() => {
            this.Loadlistaskformoney();
          }, 150);
        }
        else {
          alert("ไม่สำเร็จกรุณาลองใหม่");
        }
      }).catch(err => { throw (err) })
    }
    else { }
  }
  date2en(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  THtoLocalstring(date: any) {
    if (!date) {
      return '';
    }
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit",      //second  : "2-digit",
      timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }
}
